$('html').removeClass('no_js');
$('html').addClass('js');

var AppSettings = {
  DEBUGMODE: false //change to turn on/off console.log statements
};

/**
 * Simple debug setup for logging to the console
 * @type {Object}
 */
var Debug = {
    log: function(string, variable) {
      if (AppSettings.DEBUGMODE) {
        try {
          console.log(string, variable);
        } catch (e) {}
      }
    },
    warn: function(string, variable) {
      if (AppSettings.DEBUGMODE) {
        try {
          console.warn(string, variable);
        } catch (e) {}
      }
    }
};

var OwlCarousel = {
  latestNews: function(){
    var latestNewsSlider = $('.latestNewsSlider').owlCarousel({
      dots: false,
      margin: 40,
      responsiveClass: true,
      nav: false,
      responsive: {
        0: {
          items: 1,
          loop: true,
        },
        600: {
          items: 2,
          loop: true,
        },
        992: {
          items: 3,
          loop: false,
          margin: 50
        }
      },
      callbacks: function(){
        
      }
    })
    // latestNewsSlider.on('changed.owl.carousel', function(event) {
    //   // if ( event.item.count > this.visibleItems.length ) {
    //   //   $('.slider-btn--next.latestNews').removeClass('disabled');
    //   //   $('.slider-btn--prev.latestNews').removeClass('disabled');
    //   //   if ( this.currentItem == 0 ) {
    //   //     $('.slider-btn--prev.latestNews').addClass('disabled');
    //   //   }
    //   //   if ( this.currentItem == this.maximumItem ) {
    //   //     $('.slider-btn--next.latestNews').addClass('disabled');
    //   //   }

    //   // }
    // })

    $('.slider-btn--next.latestNews').click(function(event) {
      event.preventDefault()
      latestNewsSlider.trigger('next.owl.carousel');
    })
    $('.slider-btn--prev.latestNews').click(function(event) {
      event.preventDefault()
      latestNewsSlider.trigger('prev.owl.carousel');
    })
  },
};

var Sticky = {
  init: function(){
    "use strict"
    // Get the navigation element
    var elements = document.querySelectorAll('[data-sticky]')
      for (var i = 0; i < elements.length; i++) {
        (function(element){
          
          var offset         = element.offsetTop // automatically calculated offset
          var variableOffset = parseInt(element.getAttribute('data-offset')) || offset // offset defined in HTML data-offset
          var rect           = element.getBoundingClientRect()
          
          const offsetToUse  = variableOffset
          
          var stick = function () {

            var scroll = window.scrollY
            var isSticked = element.classList.contains('stick')

            if ( scroll >= offsetToUse && !isSticked) {
              element.classList.add('stick')
            } else if(scroll <= offsetToUse && isSticked){
              element.classList.remove('stick')
              
            }

          }

          // listen to the scroll
          window.addEventListener('scroll', stick)
        })(elements[i])
      }
    }
}
var Progress = {
  init: function(){
    $('#progress').tocProgress();
  }
}
var SwiperCall = {
  init: function(){

    var mySwiper = new Swiper('.swiper-container', {
      slidesPerView: 'auto',
      spaceBetween: 0,
      speed: 1500,
      // centeredSlides: true,
      direction: 'vertical',
      loop: false,
    
      // Navigation arrows
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
    })

    var latestSwiper = new Swiper('.latestSwiper-container', {
      slidesPerView: 'auto',
      spaceBetween: 0,
      // Navigation arrows
      navigation: {
        nextEl: '.latestSwiper-button-next',
        prevEl: '.latestSwiper-button-prev',
      },
    })

    var logoSwiper = new Swiper('.logoSwiper-container', {
      slidesPerView: 'auto',
      speed: 1500,
      loop: true,
      // centeredSlides: true,
      autoplay: {
        delay: 2500,
        disableOnInteraction: true,
      },
      navigation: {
        nextEl: '.logoSwiper-button-next',
        prevEl: '.logoSwiper-button-prev',
      },
    })
  }
}

var Tabs = {
  init: function(){
    $('.tab-list__title').click(function(event){
      event.preventDefault()
      var t = $(this).attr('id')
    
      if (!$('#' + t).hasClass('active')) {
        $('#tabs li, #tabs li a').removeClass('active')
        $('#' + t).addClass('active')
        $('#' + t).parent().addClass('active')
        
        $('.tab-content__wrapper').removeClass('active')
        $('#'+ t + 'C').addClass('active')
     }
    });
    $('.tab-content__title a').click(function(event){
      event.preventDefault()
      var t = $(this).attr('id')
      
      if (!$(this).hasClass('active')) {
        $('#tabs li, #tabs li a').removeClass('active')
        $('.tab-content__title, .tab-content__title a').removeClass('active')
        $('#component' + t).addClass('active')
        $('#component' + t).parent().addClass('active')
        
        // $('.tab-content__wrapper').removeClass('active')
        $('#component'+ t + 'C').toggleClass('active')
     }
    });
  },
}


var Cursor = {
  init: function(){

    var cursor = $(".cursor");

    $(window).mousemove(function(e) {
      cursor.css({
        top: e.clientY - cursor.height(),
        left: e.clientX - cursor.width()
      });
    });

    $(".tip-country")
    .mouseenter(function() {
      cursor.addClass("over")
    })
    .mouseleave(function() {
      cursor.removeClass("over")
    });

  }
};

var Tabs2 = {
  init: function(){
    $('.tab-list__title2').click(function(event){
      event.preventDefault()
      var t = $(this).data('target')
    
      // change tabs
      $('.tab-list__title2--li').removeClass('active')
      $(this).parent().addClass('active')
      
      //change blocks
      $('.tab-content__wrapper2').removeClass('active')
      $('#'+ t).addClass('active')

     })
  },
}


var Reports = {
  init: function(){
    Reports.headNav();
    Reports.tabs();
  },
  headNav: function(){
    $('.reportsMenuTab').click(function(event){
      event.preventDefault()
      var itemId = $(this).attr('id')

      if ($(this).hasClass('active')) {
        $(this).removeClass('active')
        $('.tab-menu__content').removeClass('active')
        $('#'+ itemId + '-block').removeClass('active')

        $('body').removeClass('hideStickySidebar')
      } else {
        $('.reportsMenuTab').removeClass('active')
        $('.tab-menu__info').addClass('d-none')

        $('body').addClass('hideStickySidebar')
        
        $(this).addClass('active')       
        $('.tab-menu__content').addClass('active') 
        $('#'+ itemId + '-block').removeClass('d-none')
      }
    });

    $('.tab-menu__close .close').click(function(event){
      event.preventDefault()

      $('.reportsMenuTab').removeClass('active')
      $('.tab-menu__content').removeClass('active')

      $('body').removeClass('hideStickySidebar')
    });

    $('.tableOfContents__content .report-image-link').click(function(event){
      $('.tab-menu__content').removeClass('active')
      $('body').removeClass('hideStickySidebar');
      $('.reportsMenuTab').removeClass('active')
    });

    $('.tableOfContents__Link').click(function(event){
      $('.reportsMenuTab').removeClass('active');
      $('.tab-menu__content').removeClass('active');

      $('body').removeClass('hideStickySidebar');
    });
  },
  tabs: function(){
    var screenwidth = $("body").width();
    if (screenwidth > 1024) {
      $('.article-accordion--head').hover(function(event){
        event.preventDefault()
        $('.article-accordion').addClass('tabOpen')
        // $(this).parent().toggleClass('tabOpen')
      });
      $('.article-accordion--head').click(function(event){
        event.preventDefault()
      });
    } else {
      $('.article-accordion--head').click(function(event){
        event.preventDefault()
        // $('.article-accordion').removeClass('tabOpen')
        $(this).parent().toggleClass('tabOpen')
      });
    }
    

    $('.tab-menu__drop--head').click(function(event){
      event.preventDefault()
      // $('.article-accordion').removeClass('tabOpen')
      if ($(this).parent().hasClass('tabOpen')) {
        $(this).parent().removeClass('tabOpen')
      } else {
        // $('.tab-menu__drop--wrap').removeClass('tabOpen')
        $(this).parent().addClass('tabOpen')
      }
    });
  },
  
}

var SearchResults = {
  init: function(){
    $('.search-result__filterBtn').click(function(event){
      event.preventDefault()
      $(this).toggleClass('active')
      $('.search-result__filterContainer').toggleClass('active')
    });
  }
}


var ToggleMenu = {
  init: function(){

    // Toggle main menu
    $(".toggle-menu").click(function(e) {
      e.preventDefault();
      $('body').toggleClass('menu-open');
    });

    // Toggle search Menu
    $(".search-trigger").click(function(e) {
      e.preventDefault();
      $('body').toggleClass('search-open');
    });
  }
}

var socialShare = {
  init: function(){
      $('.social-share-link').click(function(e) {
        e.preventDefault()
        // window.open($(this).attr('href'),'share','width=500,height=500');
      });
  }
}

var Footnotes = {
  init: function(){

    let kind = ""

    if ($(".footnote-item")[0]){
        $(".footnote-item").each((index, el) => {
          let fid = $( el ).data("target")
          kind = $( el ).data("type")
          let findex = $( el ).data("index")
          let tip = $( el ).find('.tt-content').html()
           
          $("." + fid).append(findex)
          $("." + fid).prop('title', tip);
        });
        
        $('[data-toggle="tooltip"]').tooltip({
          html:true,
          placement: 'bottom',
          trigger: 'hover',
          delay: { "hide": 2000 },
          template: '<div class="tooltip tooltip--'+ kind +'" role="tooltip"><div class="tooltip-arrow arrow"></div><div class="tooltip-inner"></div></div>'
        })

        $('[data-toggle="tooltip"]').click(function (e) {
          e.preventDefault();
          e.stopPropagation();
          $(this).tooltip("show");
        });

        $('body').click(function (e) {
          $('[data-toggle="tooltip"]').tooltip("hide");
        });


    } 
  }
}
var Veno = {
  init: function(){
    $('.venobox').venobox(); 
  }
}


var Tooltips = {
  init: function(){
    $('[data-toggle="tooltip"]').tooltip({
      html:true,
      delay: { "hide": 500 },
      template: '<div class="tooltip tooltip--plain" role="tooltip"><div class="tooltip-arrow arrow"></div><div class="tooltip-inner"></div></div>'
    })
    // $('[data-toggle="tooltip"]').tooltip('show')
  }
}


var AddAResource = {
  setup: function(){

    var $fileInput = $('.file-input');
    var $droparea = $('.file-drop-area');

    // highlight drag area
    $fileInput.on('dragenter focus click', function() {
      $(this).parent('.file-drop-area').addClass('is-active');
    });
    
    // back to normal state
    $fileInput.on('dragleave blur drop', function() {
      $(this).parent('.file-drop-area').removeClass('is-active');
    });
    
    // change inner text
    $fileInput.on('change', function() {
      var filesCount = $(this)[0].files.length
      var $textContainer = $(this).parent('.file-drop-area').find('.file-msg')
    
      if (filesCount == 0) {
        $(this).parent('.file-drop-area').removeClass('hasFile');

      } else if (filesCount === 1) {
        $(this).parent('.file-drop-area').addClass('hasFile');

        // if single file is selected, show file name
        var fileName = $(this).val().split('\\').pop();
        $textContainer.text(fileName );
      } else {
        $(this).parent('.file-drop-area').addClass('hasFile');
        
        // otherwise show number of files
        $textContainer.text(filesCount + ' files selected');
      }
    });

    AddAResource.init();
  },
  init: function(){
    var form = $('.newResourceForm')
    
    form.find('.btn[type=submit]').click(function (element) {
      form.find('input[required], textarea[required]').closest('.form-group').addClass('required')

      form.find('input[type=file]:invalid').closest('.form-group').find('.file-drop-area').addClass('required')
    })
  }
}



var DownloadAnnex = {
  init: function(){
    $('[data-toggle="tooltip"]').tooltip({
      html:true,
      delay: { "hide": 500 },
      template: '<div class="tooltip tooltip--plain" role="tooltip"><div class="tooltip-arrow arrow"></div><div class="tooltip-inner"></div></div>'
    })
    // $('[data-toggle="tooltip"]').tooltip('show')
  }
}


var DownloadAnnex = {
  init: function(){
    $('#download-button').click(function() {
      var ele = document.getElementById('download-pdf');
      var opt = {
        margin:       0,
        filename:     'annex-checklist.pdf',
        image:        { type: 'jpeg', quality: 0.98 },
        html2canvas:  { scale: 1 },
        jsPDF:        { unit: 'in', format: 'letter', orientation: 'portrait' }
      };
      html2pdf(ele, {
        jsPDF: { 
          unit: 'in', 
          format: 'letter', orientation: 'portrait',
          filename:     'annex-checklist.pdf' 
        }
      });
    })
  }
}
var AjaxForm = {
  init: function(){
    $.ajaxSetup({
        headers: { 'X-CSRF-TOKEN': $('input[name="_token"]').val() }
    });


    var the_form = $('.contact-form form');

    the_form.submit(function(event) {
        
      var formData = $(the_form).serialize();
      event.preventDefault();
      the_form.find("button").text("Sending");

      $.ajax({ 
          type: 'POST',
          url: $(the_form).attr('action'),
          data: formData,
          beforeSend: function(xhr) {
            xhr.setRequestHeader( 'X-CSRF-Token', $(the_form).find('input[name="_token"]').val() );
          },
          success: function(msg) {
            event.preventDefault();
            the_form.find("button").text("Sent").toggleClass("sent");
            the_form.find('.form-success').removeClass('hidden');
            setTimeout(function() {
                the_form.find('.form-success').addClass('hidden');
            }, 5000);
          },
          error: function(jqXhr, textStatus, errorThrown) {
              console.log(textStatus + ': ' + errorThrown);
          }
      }).fail(function(jqXHR, textStatus, errorThrown) {
          console.log(textStatus + ': ' + errorThrown);
      });
      
    });
  }
}

var HeadroomFunction = {
  init: function(){
    var options = {
      // vertical offset in px before element is first unpinned
      offset : 100,
      // scroll tolerance in px before state changes
      // tolerance :5,
      // or you can specify tolerance individually for up/down scroll
      tolerance : {
          up : 5,
          down : 0
      }
    }
    $(".body__inner").headroom(options);
  }
};

var toggleFilter = {
  init: function(){
    $('.filter-toggle').click(function() {
      let target = $(this).data('target')
      $('#'+target).toggleClass('active')
    })


    $('.close-filter-menu').click(function() {
      $('.filter__popper').removeClass('active');
    })
  }
};

var switchTitle = {
  init: function(){
    let txt = $('#mainTitle').html()
    $('span.makeTitle').html(txt)
  }
};

var sidebar = {
  init: function(){
    $('.openSidebar').click(function(event){
      event.preventDefault();
      
      if ($(this).hasClass('isOpen')) {
        $(this).removeClass('isOpen');
        $('.sidebarContainer').removeClass('show');
      } else {
        $(this).addClass('isOpen');
        $('.sidebarContainer').addClass('show');
      }
    });

    $('.openSidebar.isOpen').click(function(event){
      event.preventDefault();
    });
  }
};


var Main = {
  run: function() {
    Debug.log('Custom Scripts Running');
    Sticky.init();
    Progress.init();
    OwlCarousel.latestNews();
    SwiperCall.init();
    Tabs.init();
    Tabs2.init();
    Reports.init();
    socialShare.init();
    ToggleMenu.init();
    Footnotes.init();
    Tooltips.init();
    AddAResource.setup();
    Cursor.init();
    Veno.init();
    DownloadAnnex.init();
    AjaxForm.init();
    HeadroomFunction.init();
    toggleFilter.init();
    switchTitle.init();
    sidebar.init();
  }
};

$(document).ready(Main.run);
